var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/named */
/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DeleteAdContainer from './containers/DeleteAdContainer';
var Eliminator = function (_Component) {
  _inherits(Eliminator, _Component);
  function Eliminator(props) {
    _classCallCheck(this, Eliminator);
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
    _this.state = {
      showModal: false
    };
    _this.handleOpenModal = _this.handleOpenModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    return _this;
  }
  Eliminator.prototype.handleOpenModal = function handleOpenModal() {
    this.setState({
      showModal: true
    });
  };
  Eliminator.prototype.handleCloseModal = function handleCloseModal() {
    this.setState({
      showModal: false
    });
    this.props.onCloseModal();
  };
  Eliminator.prototype.render = function render() {
    var _props = this.props,
      title = _props.title,
      listId = _props.listId,
      adId = _props.adId,
      onAdDeletedSuccess = _props.onAdDeletedSuccess,
      noSurvey = _props.noSurvey;
    return React.createElement('div', null, this.state.showModal && React.createElement(DeleteAdContainer, {
      title: title,
      adId: adId,
      listId: listId,
      onClose: this.handleCloseModal,
      isOpen: this.state.showModal,
      onAdDeletedSuccess: onAdDeletedSuccess,
      noSurvey: noSurvey
    }));
  };
  return Eliminator;
}(Component);
Eliminator.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  adId: PropTypes.string,
  listId: PropTypes.string,
  onAdDeletedSuccess: PropTypes.func,
  onCloseModal: PropTypes.func,
  noSurvey: PropTypes.bool
} : {};
export default React.forwardRef(function (props, ref) {
  return React.createElement(Eliminator, _extends({
    ref: ref
  }, props));
});